<template>
  <button
    class="remake_btn"
    v-if="descendantsCounts"
    @click.stop="openRemakesFeed(post)"
  >
    <img src="/remake-btn.svg" alt="Reameke" loading="lazy" />
    <p>{{ descendantsCounts }}</p>
  </button>
</template>

<script>
import { useModalStore } from "@/stores/modalStore";
import { useOpenRemakesFeed } from "../../composables/useOpenRemakesFeed.js";

export default {
  name: "RemakeBtn",
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalStore: useModalStore(),
      openRemakesFeed: useOpenRemakesFeed().openRemakesFeed,
    };
  },
  computed: {
    descendantsCounts() {
      return this.post?.first_descendants?.length || 0;
    },
  },
};
</script>

<style>
.remake_btn {
  position: relative;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: bold;
  border: none;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.remake_btn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  padding: 2px;
  background: linear-gradient(45deg, #ff8e58, #ffcc02);
  background-position: 0 0;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  transition: 0.3s ease-in-out;
}

.remake_btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.remake_btn:hover::before {
  background: linear-gradient(300deg, #ff8e58, #ffcc02);
}

.post_bottom_margin {
  width: 250px;
}
</style>
